import { m as motion } from "motion/react";
import { useAnimateFadeIn } from "../../../animation/animation";
import styles from "./hero-text-block.module.less";

type THeroTextBlockProps = {
  title: string;
  preamble?: string;
};

const HeroTextBlock = ({ title, preamble }: THeroTextBlockProps) => {
  const fadeInAnimation = useAnimateFadeIn({ whileInView: true, easing: "easeInOut" });

  return (
    <motion.section {...fadeInAnimation} className={["max-width padded-sides", styles.wrapper].join(" ")}>
      <div className={[styles.innerWrapper, "text-max-width"].join(" ")}>
        <h1>{title}</h1>
        {preamble && <p className={`body-l`}>{preamble}</p>}
      </div>
    </motion.section>
  );
};

export default HeroTextBlock;
export { HeroTextBlock };
